<template>
    <div class="support_chat_ws_wrp">
        <div id="sidepanel">
            <div id="search">
                <div class="row align-items-center">
                    <div class="col-auto">
                        <h3 class="support_chat_heading">Bot Ticket Support</h3>
                    </div>
                    <!-- <div class="col text-right chat_menuburger_wrp pl-2">
                        <selfUserStatus></selfUserStatus>
                    </div> -->
                </div>
            </div>
            <div class="user_search_for_new_chat" :class="{ 'search_enabled': isSearchEnabled }"
                v-click-outside="outsideClickOfSearchFieldMethod">
                <div class="search_for_new_chat_inner">
                    <span class="back">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                            @click="searchBarForChatClosedFun">
                            <path fill="#ffd400" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"></path>
                        </svg>
                    </span>
                    <span class="search">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                            <path fill="#ffffff"
                                d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z">
                            </path>
                        </svg>
                    </span>
                    <input class="form-control" v-model="search_term" placeholder="Search or start new chat"
                         @focus="handleSearchbarFocus">
                    <span class="x-alt" @click="searchBarForChatClosedFun"
                        :class="{ 'search_disabled_btn': search_term }">
                        <svg height="15px" viewBox="0 0 329.26933 329" width="15px" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#f44336">
                                <path
                                    d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0" />
                                <path
                                    d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0" />
                            </g>
                        </svg>
                    </span>
                </div>
            </div>
            <div id="contacts_list" ref="chatList" @scroll="handleScroll">
                <!-- Connected Room List -->
                <div class="user_list_for_chat" v-if="fullChatData">
                    <ul>
                        <template v-if="filteredSupportUsers && filteredSupportUsers.length > 0">
                            <li class="contact chat_user_listed"
                                v-for="(chatItemInfo, index) in filteredSupportUsers"
                                :key="chatItemInfo.ticket_number" :id="'userChatListingId' + chatItemInfo.ticket_number"
                                :style="{ 'order': index + 1 }"
                                :class="chatItemInfo.ticket_number == (chatRoomInfo && chatRoomInfo.ticket_number) ? 'active' : ''">
                                <div class="wrap chats_tab_name"
                                    @click="selectChatRoomForMessageMethod(chatItemInfo)">
                                    <span class="user_prfl_status">
                                        <!-- <img :src="chatItemInfo.user.profile.thumbnail"
                                            v-if="chatItemInfo.user.profile.thumbnail" class="chat_user_photo"> -->
                                        <img src="@/assets/images/user_circle_avtar.png" alt="" />
                                    </span>
                                    <div class="meta">
                                        <p class="name">
                                            {{ chatItemInfo.user_info.full_name }} - <span>{{ chatItemInfo.ticket_number }}</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
                <div id="vac-circle" v-else></div>
                <!-- Connected Room List -->
                <div id="vac-circle" v-if="chatListAPILoader" class="mt-2 mb-2"></div>
            </div>
        </div>
        <user-chat-info :selectedChatRoomData="chatRoomInfo"></user-chat-info>
    </div>
</template>

<script>
/*eslint-disable */

import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import axios from 'axios';
import {
    bus
} from '@/main';
import {
    mapGetters
} from 'vuex';
import moment from 'moment';
import responsiveMixin from '@/mixins/responsive';

const $ = window.jQuery = require('jquery');


// Lazy load components
const selfUserStatus = () => import('@/components/private/workspace/self-user-status');
const chatInfoSection = () => import('@/components/botTickets/workspace/chat-info.vue/');


export default {
    name: 'support-chat-user-list',
    mixins: [responsiveMixin],
    components: {
        selfUserStatus,
        'user-chat-info': chatInfoSection,
    },
    props: [],
    data() {
        return {
            selfUserId: '',
            search_term: '',
            fullChatRoomListData: null,
            fullChatRoomListResult: [],
            fullChatListForLoadMore: '',
            typingUserInfoState: '',
            chatRoomInfo: null,
            searchingContactText: 'Looking for contact',
            chatListAPILoader: false,
            isSearchEnabled: false
        }
    },
    computed: {
        ...mapGetters([
            'acUserDetailsStateGetters',
            'ticketChatListGetters',
        ]),
        selfUserInfo() {
            return this.$store.getters.acUserDetailsStateGetters.data;
        },
        fullChatData() {
            return this.$store.getters.ticketChatListGetters.data;
        },
         // Filtered list based on search_filter
        filteredSupportUsers() {
            if (this.search_term) {
                const lowerCaseFilter = this.search_term.toLowerCase();
                return this.fullChatRoomListResult.filter((item) =>
                item.user.first_name.toLowerCase().startsWith(lowerCaseFilter)
                );
            }
            return this.fullChatRoomListResult;
        },
    },
    created() {
        this.initializeChatData();
    },
    mounted() {
        this.selfUserId = localStorage.getItem('LoginedUserID');
        // Typing For Selected User Event Listener
        bus.$on('typingEventForChatBus', (data) => {
            this.typingUserInfoState = data;
            if (data.message == 'stop') {
                this.typingUserInfoState = '';
            }
        });

        // User Status Update Event Listener
        bus.$on('userUpdateStatus', (data) => {
            let targetUserId = this.fullChatRoomListResult.find(item => item.user && item.user.id === data.userID);
            if (targetUserId) {
                targetUserId.user.is_online = data.is_online;
            }
        });

        // User Self Status Event Listener
        bus.$on('userSelfStatus', (data) => {
            let targetUserId = this.fullChatRoomListResult.find(item => item.user && item.user.id === data.userID);
            if (targetUserId) {
                targetUserId.user.current_status = data.current_status;
                targetUserId.user.status_time = data.status_time;
            }
        });

        // Update Message Notification Event Listener
        bus.$on('updateMessageNotification', (data) => {
            let currentSelected = this.chatRoomInfo;
            currentSelected = currentSelected.id;
            if (data.chatRoomId == currentSelected) return;
            this.handleChatRoomNotification(data, currentSelected);
        });
        // Unread Message Count All Cleared For User Event
        bus.$on('unreadCountClearedForUserBus', (data) => {
            if (data == true) {
                let currentSelected = this.chatRoomInfo;
                let targetUserChatRoom = this.fullChatRoomListResult.find(item => item.ticket_number === currentSelected.ticket_number);
                if (targetUserChatRoom) {
                    targetUserChatRoom.unread_count = 0;
                }
            }
        });
        // Self User Chat List Live Update
        bus.$on('selfFullChatListOrdChangedBus', (data) => {
            if (data) {
                this.moveToTopIndexSelectedUserOfLiveChatMethod(data);
            }
        });

        $('.chat_menuburger').click(function () {
            $('.chat_menuburger_wrp').toggleClass('active');
        })
        $(document).click(function (event) {
            //if you click on anything except the modal itself or the "open modal" link, close the modal
            if (!$(event.target).closest(".chat_menuburger, .chat_menu_list").length) {
                $(".chat_menuburger_wrp").removeClass("active");
            }
        });
        // Mobile View In Chat Disabled Event Listener
        bus.$on('hideChatSectionInMblBus', (data) => {
            if (data) {
                this.chatRoomInfo = null;
            }
        });
    },
    methods: {
        mblToolbarEnabledMethod() {
            const frame = document.getElementById('frame');
            if (frame) {
                frame.classList.add('acvt_toolbar');
            }
        },
        handleChatRoomNotification(data) {
            let targetUserChatRoom = this.fullChatRoomListResult.find(item => item.ticket_number === data.chatRoomId);

            if (targetUserChatRoom) {
                if (this.fullChatRoomListResult.includes(targetUserChatRoom)) {
                    this.moveToTopIndexSelectedUserOfLiveChatMethod(data.chatRoomId);
                }
                this.handleNotification(targetUserChatRoom, data);
            }
        },
        handleNotification(room, data) {
            const unreadByRoom = data.unreadByRoom;
            const countForSpecificId = unreadByRoom[room.ticket_number];
            if (countForSpecificId > 0) {
                if (Push.Permission.has()) {
                    Push.create(data.senderName, {
                        body: data.message,
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    });
                    room.unread_count = countForSpecificId;
                } else {
                    room.unread_count = countForSpecificId;
                    this.playSound(audioPlay); // Assuming playSound is a method of 'this'
                }
            }
        },
        initializeChatData() {
            if (this.fullChatData) {
                this.fullChatRoomListResult = this.fullChatData.results || [];
                this.fullChatListForLoadMore = this.fullChatData.next || '';
                this.setInitialChatRoom();
            }
        },
        setInitialChatRoom() {
            if (this.fullChatRoomListResult.length > 0) {
                if (this.isMobile) return;
                this.chatRoomInfo = this.fullChatRoomListResult[0];
            }
        },
        // Chat user List Pagination Of The Event Listener
        handleScroll() {
            const chatListEl = this.$refs.chatList;
            let yScrollHeight = chatListEl.scrollHeight;
            let scrollTopEvt = chatListEl.scrollTop + chatListEl.clientHeight + 1;
            if (scrollTopEvt > yScrollHeight) {
                if (this.fullChatListForLoadMore) {
                    if (!this.chatListAPILoader) {
                        this.chatListAPILoader = true;
                        axios.get(this.fullChatListForLoadMore).then((response) => {
                            this.fullChatRoomListResult = [].concat(this.fullChatRoomListResult, response.data.data.results);
                            this.fullChatListForLoadMore = response.data.data.next;
                            this.chatListAPILoader = false;
                        })
                    }
                }
            }
        },
        /*
         * this will check the new message notification
         */
        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        /*
         * Get Minutes From Status Time Methods
         */
        getStatusTimeOfMinMethod(sc) {
            var cth = moment().format('HH');
            var ctm = moment().format('mm:ss');
            var sth = moment(sc).format('HH');
            var stm = moment(sc).format('mm:ss');
            var cft = cth * parseInt(60) + parseInt(ctm);
            var sft = sth * parseInt(60) + parseInt(stm);
            var nt = cft - sft;
            return nt;
        },
        // User Searchbar Styling for Code Here
        handleSearchbarFocus() {
            this.isSearchEnabled = true;
        },
        /*
         * This Will Close User Searchbar
         */
        searchBarForChatClosedFun() {
            this.search_term = '';
            this.isSearchEnabled = false;
        },
        outsideClickOfSearchFieldMethod() {
            if (this.search_term.length > 0) return;
            this.isSearchEnabled = false;
            this.search_term = '';
        },
        selectChatRoomForMessageMethod(roomInfo) {
            if (!roomInfo) return;
            if ((this.chatRoomInfo && this.chatRoomInfo.ticket_number) == roomInfo.ticket_number) return;
            this.chatRoomInfo = roomInfo;
            if (!this.isMobile) return;
            this.showMenuBarOnMblMethod();
        },

        showMenuBarOnMblMethod() {
            // Get the element with id 'sidepanel'
            const sidepanel = document.getElementById('sidepanel');
            if (sidepanel) {
                sidepanel.classList.add('d-none');
            }

            // Get the element with id 'chatContentWrp'
            const chatContentWrp = document.getElementById('chatContentWrp');
            if (chatContentWrp) {
                chatContentWrp.classList.add('d-block');
            }
        },

        /*
         * This Will Move On Top Selected User From List
         */
        moveToTopIndexSelectedUserOfLiveChatMethod(itemId) {
            const itemIndex = this.fullChatRoomListResult.findIndex(item => item.ticket_number === itemId);
            if (itemIndex) {
                this.fullChatRoomListResult.unshift(this.fullChatRoomListResult.splice(itemIndex, 1)[0])
            }
        },
    },
    watch: {
        fullChatData: {
            handler() {
                this.initializeChatData();
            },
            deep: true,
        },
    }
}
</script>

<style lang="scss" scoped>
.support_chat_ws_wrp {
    height: 100%;
    width: 100%;
    float: left;
    transition: all ease-in-out 0.5s;
    -webkit-transition: all ease-in-out 0.5s;
    -moz-transition: all ease-in-out 0.5s;

    @media only screen and (max-width:769px) {
        width: 100%;
    }
    .support_chat_heading {
        font-size: 19px;
        font-weight: normal;
        color: #fbf7a5;
        margin: 0;
    }
    #sidepanel {
        width: 420px;
        float: left;
        height: 100%;
        background: #111111;
        color: #f5f5f5;
        overflow: hidden;
        position: relative;
        transition: all ease-in-out 0.5s;
        -webkit-transition: all ease-in-out 0.5s;
        -moz-transition: all ease-in-out 0.5s;

        @media only screen and (max-width:769px) {
            width: 100%;
        }
    }

    .content {
        width: calc(100% - 420px);
        transition: all ease-in-out 0.5s;
        -webkit-transition: all ease-in-out 0.5s;
        -moz-transition: all ease-in-out 0.5s;

        @media only screen and (max-width:769px) {
            width: 100%;
            display: none;
        }
    }
}

#sidepanel {
    #search {
        font-weight: 300;
        padding: 10px;

        label {
            position: absolute;
            margin: 8px 0 0 20px;
        }

        input {
            font-family: "proxima-nova", "Source Sans Pro", sans-serif;
            padding: 10px 10px 10px 46px;
            width: 100%;
            border: none;
            background: #111111;
            color: #f5f5f5;
            font-size: 14px;

            &:focus {
                outline: none;
                background: #232323;
            }

            &::-webkit-input-placeholder {
                color: #f5f5f5;
            }

            &::-moz-placeholder {
                color: #f5f5f5;
            }

            &:-ms-input-placeholder {
                color: #f5f5f5;
            }

            &:-moz-placeholder {
                color: #f5f5f5;
            }
        }
    }

    #contacts_list {
        ul {
            margin: 0;

            li.contact {
                position: relative;
                padding: 10px;
                border-right: 5px solid transparent;

                &:hover {
                    background: #181c1f;
                }

                &.active {
                    background: #1d2226;

                    span.contact-status {
                        border: 2px solid #111111 !important;
                    }
                }

                .wrap {
                    width: 100%;
                    position: relative;
                    clear: both;
                    display: flex;
                    align-items: center;
                    padding-right: 50px;

                    &.chats_tab_name {
                        cursor: pointer;
                    }

                    .user_prfl_status {
                        width: 44px;
                        border-radius: 50%;
                        position: relative;
                        margin-right: 10px;
                        height: 44px;
                        flex: 0 0 44px;

                        img {
                            width: 100%;
                            border-radius: 50%;
                            height: 100%;
                            object-fit: cover;
                            object-position: top center;
                        }
                    }

                    .unread_msg {
                        margin-left: 5px;
                        font-size: 11px;
                        vertical-align: middle;
                        display: inline-block;
                        background: #87cefa;
                        border-radius: 50%;
                        color: #000000;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        font-weight: 600;
                    }

                    .meta {
                        .name {
                            margin: 0px;
                            max-width: 100%;
                            font-size: 18px;
                        }

                        .preview {
                            margin: 5px 0 0 0;
                            padding: 0 0 1px;
                            font-weight: 400;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            -moz-transition: 1s all ease;
                            -o-transition: 1s all ease;
                            -webkit-transition: 1s all ease;
                            transition: 1s all ease;

                            span {
                                position: initial;
                                border-radius: initial;
                                background: none;
                                border: none;
                                padding: 0 2px 0 0;
                                margin: 0 0 0 1px;
                                opacity: .5;
                            }
                        }
                    }

                    &.chats_tab_name .meta .name {
                        max-width: 260px;
                    }
                }
            }

        }

        &.expanded {
            height: calc(100% - 334px);
        }
    }

    .chat_menuburger_wrp {
        position: relative;

        .chat_menuburger {
            display: inline-block;
            width: 10px;
            height: 21px;
            text-align: center;
            position: relative;
            vertical-align: middle;
            margin-right: 0px;
            cursor: pointer;

            &>span {
                display: inline-block;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: #fff;
                position: absolute;
                left: 0;
                right: 0;
                margin: 0 auto;

                &:first-child {
                    top: 0;
                }

                &:nth-child(2) {
                    top: 8px;
                }

                &:nth-child(3) {
                    top: 16px;
                }
            }
        }

        .chat_menu_list {
            margin: 0;
            background: #000;
            position: absolute;
            right: 13px;
            top: 35px;
            z-index: 100;
            width: 115px;
            text-align: center;
            padding: 5px 0;
            border-radius: 2px;
            display: none;
            border: 1px solid #ffc107;

            &:before {
                width: 0;
                border-bottom: 7px solid #ffc107;
                border-right: 7px solid transparent;
                border-left: 7px solid transparent;
                content: "";
                position: absolute;
                top: -8px;
                right: 0;
            }

            li {
                padding: 3px 10px;

                a {
                    color: #ffc107;
                    font-size: 13px;
                    font-family: "proxima-nova", "Source Sans Pro", sans-serif;
                    text-decoration: none;
                    font-weight: 500;
                    letter-spacing: 0.3px;

                    &:hover {
                        color: #ffffff;
                    }
                }
            }
        }

        &.active .chat_menu_list {
            display: block;
        }

        .btn-default {
            padding: 7px 15px;
            font-size: 15px;
            border-radius: 70px;
            background: rgba(255, 255, 255, 0.12);
            color: #ffd400;
            border: none;
            margin-right: 5px;
            text-transform: capitalize;
            font-weight: 400;
            letter-spacing: .03em;
            line-height: 1;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            box-shadow: none !important;

            &:hover {
                background: #87cefa;
                color: #22292f;
            }
        }
    }

    .btn {
        outline: none !important;
        box-shadow: none !important;
    }

    .btn-primary {
        &.team_group_create_btn {
            text-align: center;
            font-family: AceSansDemo;
            font-size: 17px;
            display: inline-block;
            padding: 7px 10px;
            letter-spacing: 1px;
            border-radius: 3px;
            min-width: 80px;
            border: none;
            line-height: 1;
            outline: none;
            -webkit-box-shadow: none;
            box-shadow: none;
            border: 2px solid #ff4338;
            color: #fff;
            background: none;
            font-weight: 700;

            &:hover {
                background: #ffd400;
                color: #000;
                border-color: #ffd400;
            }
        }

        &.message_request_btn {
            font-size: 16px;
            background: rgba(255, 255, 255, 0.07);
            border: none;
            color: #fff;
            position: absolute;
            right: 50px;
            top: 50%;
            border-radius: 3px;
            padding: 5px;
            letter-spacing: 0px;
            line-height: 1;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
            min-width: 36px;
            height: 34px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);

            .calling_txt {
                display: none;
            }

            &:hover,
            &.call_actv {
                background: #87cefa !important;
                color: #000 !important;

                svg path,
                svg path {
                    fill: #000000;
                }
            }

            &.call_actv {
                .calling_txt {
                    display: inline-block;
                }
            }

            &.call_actv {
                .call_txt {
                    display: none;
                }
            }

            &.video_call_request {
                right: 5px;
            }
        }
    }

    .user_search_for_new_chat {
        padding: 10px;
        background: none;
        border: 1px solid transparent;
        border-bottom-color: #171b1f;

        .search_for_new_chat_inner {
            position: relative;
            background: none;
            border-radius: 80px;
            padding: 0;
            border: 3px solid rgba(255, 255, 255, 0.15);

            .back {
                display: none;
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                cursor: pointer;

                &.actv_action svg path {
                    fill: #ffd400;
                }
            }

            .search {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
            }

            .x-alt {
                position: absolute;
                right: 15px;
                top: 45%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                display: none;
                cursor: pointer;

                svg:hover path {
                    fill: #87cefa;
                }

                &.search_disabled_btn {
                    display: block;
                }
            }

            .form-control {
                background: none;
                border: none;
                color: #ffffff;
                padding: 8px 45px;
                height: auto;
                font-size: 16px;
                outline: none;
                box-shadow: none;
                color: #ffd400;

                &::placeholder,
                &::-webkit-input-placeholder,
                &::-moz-placeholder {
                    color: rgba(255, 255, 255, 0.6);
                }

                &:focus::-webkit-input-placeholder {
                    font-size: 0;
                }

                &:focus::-moz-placeholder {
                    font-size: 0;
                }

                &:focus+.back path,
                &.active+.back path {
                    fill: #ffd400;
                }
            }
        }

        &.search_enabled,
        &.searching_enabled {
            .search_for_new_chat_inner {
                border: 3px solid #ffd400;

                .search {
                    display: none;
                }

                .back {
                    display: block;
                }
            }
        }
    }

    .video_calling_btn_wrp {
        &.disabled_btn_global {
            opacity: 1 !important;

            .call_txt {
                opacity: 0.65;
            }

            &:hover {
                background: rgba(135, 206, 250, 0.65) !important;
            }
        }

        &:hover .user_offline_tooltip {
            display: block;
        }
    }

    .video_call_request:disabled {
        cursor: not-allowed;
        opacity: 0.4;
    }

    @keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-webkit-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-moz-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-o-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }


    .typing_info_text {
        font-size: 14px;
        color: #00de09;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        display: block;
    }

    .user_list_for_chat {
        ul {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;

            li.chat_user_listed {
                width: 100%;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 100%;
                flex: 0 0 100%;
                -ms-flex-order: 100;
                order: 100;
                transition: order cubic-bezier(0.4, 0, 1, 1) 0.5s;
                -webkit-transition: order cubic-bezier(0.4, 0, 1, 1) 0.5s;
                -moz-transition: order cubic-bezier(0.4, 0, 1, 1) 0.5s;

                &:hover {
                    .status_tootip_wrp {
                        opacity: 1;
                        visibility: visible;
                    }
                }
            }
        }
    }

    .collsaped_chatlist_menu {
        text-align: right;
        padding: 10px 15px;
        display: none !important;

        .fa-bars {
            font-size: 22px;
            color: #9b9b9b;
            cursor: pointer;
        }

        .active .fa-bars {
            color: #ffc107;
        }
    }

    .contact {
        .wrap {
            .meta {
                .name {
                    opacity: 1;
                    overflow: visible;
                    white-space: normal;
                    visibility: visible;
                    width: 100%;

                    &.active {
                        white-space: nowrap;
                        opacity: 0;
                    }
                }
            }
        }
    }

    #search.active .chat_menuburger_wrp {
        display: none
    }

    .status_tootip_wrp {
        background: #ffdee3;
        color: #000;
        position: absolute;
        right: 45px;
        top: 0;
        z-index: 1000;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 5px 10px;
        opacity: 0;
        visibility: hidden;
        transition: all ease-in-out 0.5s;
        -webkit-transition: all ease-in-out 0.5s;
        -moz-transition: all ease-in-out 0.5s;

        span {
            display: block;
            line-height: 1;

            &.current_status_text {
                font-size: 14px;
                margin-bottom: 3px;
            }

            &.status_time_text {
                font-size: 13px;
                color: #5c5c5c;
            }
        }
    }

    .user_prfl_status {
        .online-status {
            position: absolute;
            left: 32px;
            bottom: 4px;
            border: 1px solid #9E9E9E;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            background: #9E9E9E;

            &.available {
                background-color: #38b124;
                border-color: #38b124;
            }

            &.be_right_back {
                background-color: #f3d32d;
                border-color: #f3d32d;
            }

            &.lunch_away {
                background-color: #1483E5;
                border-color: #1483E5;
            }

            &.busy {
                background-color: #ee0809;
                border-color: #ee0809;
            }

            &.at_a_meeting {
                background-color: #f66c11;
                border-color: #f66c11;
            }

            &.online {
                background-color: #4CAF50;
                border-color: #4CAF50;
            }

            &.away {
                background-color: #f1c40f;
                border-color: #f1c40f;
            }

            &.busy {
                background-color: #F44336;
                border-color: #F44336;
            }
        }
    }
}

#sidepanel:not(.collapsed_chat_list) {
    #contacts_list {
        height: calc(100% - 120px);
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            width: 4px;
            background: #00000016;
        }

        &::-moz-scrollbar {
            width: 4px;
            background: #00000016;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #232323;
        }

        &::-moz-scrollbar-thumb {
            background-color: #232323;
        }
    }
}

@-webkit-keyframes vac-spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    to {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes vac-spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    to {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

#sidepanel #vac-circle {
    margin: auto;
    height: 28px;
    width: 28px;
    border: 3px rgba(0, 0, 0, 0.25) solid;
    border-top: 3px #c0bebe solid;
    border-right: 3px #c0bebe solid;
    border-bottom: 3px #c0bebe solid;
    border-radius: 50%;
    -webkit-animation: vac-spin 1s infinite linear;
    -moz-animation: vac-spin 1s infinite linear;
    animation: vac-spin 1s infinite linear;
    margin-top: 25vh;
}

#frame.collapsed_chat_list {
    #sidepanel {
        width: 145px;

        #contacts_list {
            height: 100%;
        }
    }

    .support_chat_ws_wrp {
        width: 50%;

        .content {
            width: calc(100% - 147px);
        }
    }

    #search,
    .user_search_for_new_chat {
        display: none !important;
    }

    .collsaped_chatlist_menu {
        display: block !important;

        .btn-primary {
            min-width: 65px;
            padding: 5px;
            font-size: 16px;
        }
    }

    .chat_menu_list {
        top: 28px !important;
    }
}
#sidepanel #contacts_list ul li.contact .wrap .meta .name span {
    font-size: 14px;
    color: #4c4c4a;
}
@media only screen and (min-width:768px) and (max-width:1310px) {
    #sidepanel .chat_menuburger_wrp .btn-default {
        font-size: 13px;
        padding: 6px 8px;
    }

    #sidepanel .btn-primary.team_group_create_btn {
        font-size: 13px;
        padding: 6px;
        min-width: 70px;
    }

    #sidepanel #contacts_list ul li.contact .wrap .meta .name {
        font-size: 16px;
    }

    .content .contact-profile p {
        font-size: 16px;
    }

    #sidepanel .user_search_for_new_chat .search_for_new_chat_inner .form-control {
        font-size: 14px;
    }
}
</style>